
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface TimelineMarkersProps {
  startDate: Date;
  endDate: Date;
}

export function generateMonthMarkers({ startDate, endDate }: TimelineMarkersProps) {
  const isMobile = useIsMobile();
  
  // Create simpler markers for mobile - only show 2 markers (start and end) for smallest screens
  if (isMobile) {
    const markers = [];
    
    // Add starting point
    markers.push({
      label: "Start",
      position: 0,
      isStart: true
    });
    
    // Add end point
    markers.push({
      label: "End",
      position: 100,
      isEnd: true
    });
    
    return (
      <>
        {markers.map((marker, index) => (
          <div 
            key={index}
            className="absolute text-xs border-l pl-1 text-muted-foreground h-3"
            style={{ left: `${marker.position}%` }}
          >
            {marker.label}
          </div>
        ))}
      </>
    );
  }
  
  // Desktop version with fewer markers for better readability
  const markers = [];
  
  // Add starting point
  markers.push({
    label: "Start",
    position: 0,
    isStart: true
  });
  
  // Add markers at fewer fixed intervals - reduced to just 2 markers for clarity
  for (let i = 1; i <= 2; i++) {
    markers.push({
      label: `M${i*3}`,  // Month marker (M3, M6)
      position: i * 33,  // Position at 33% and 66%
      isStart: false
    });
  }
  
  // Add end point
  markers.push({
    label: "End",
    position: 100,
    isEnd: true
  });
  
  return (
    <>
      {markers.map((marker, index) => (
        <div 
          key={index}
          className="absolute text-xs border-l pl-1 text-muted-foreground h-4"
          style={{ left: `${marker.position}%` }}
        >
          {marker.label}
        </div>
      ))}
    </>
  );
}

export const TimelineMarkers: React.FC<TimelineMarkersProps> = ({ startDate, endDate }) => {
  return generateMonthMarkers({ startDate, endDate });
};
